import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import { checkImageValidation } from "../../../utils/Common";

const EditOrganizer = () => {
    const { o_id } = useParams(); // Get organizer ID from the URL (assuming the URL is like /edit-organizer/:id)
    const navigate = useNavigate();
    const { postRequestByFormData, getRequest } = useRequests();

    const [formData, setFormData] = useState({
        organizer_name: "",
        logo: "",
        email: "",
        contact_person: "",
        phone_no: "",
        status: "Enable",
        account_number: "",
        re_account_number:"",
        ifsc_code: "",
        beneficiary_name: ""
    });

    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });

    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
    };

    const [File, setFile] = useState();
    const [FileName, setFileName] = useState('');

    // Fetch the existing organizer details
    useEffect(() => {
        const fetchOrganizerData = async () => {
            try {
                const res = await getRequest(`organizer/${o_id}`); // Assuming o-get/:id fetches organizer by ID
                if (res && res.code === 200) {
                    const {
                      first_name,
                      last_name,
                      email,
                      contact_person,
                      phone_no,
                      status,
                      logo,
                      account_number,
                      re_account_number,
                      ifsc_code,
                      beneficiary_name,
                    } = res.data;
                    setFormData({
                        organizer_name: `${first_name} ${last_name}`,
                        email,
                        contact_person,
                        phone_no,
                        account_number,
                        re_account_number: account_number,
                        ifsc_code,
                        beneficiary_name,
                        status,
                        logo, // Save logo URL to display it in the form
                    });
                } else {
                    setAlertData({
                        variant: 'error',
                        message: res.message || 'Failed to fetch organizer details.',
                    });
                    resetAlertData();
                }
            } catch (error) {
                console.error('Error fetching organizer data:', error);
                setAlertData({
                    variant: 'error',
                    message: 'An error occurred while fetching organizer details.',
                });
                resetAlertData();
            }
        };

        fetchOrganizerData();
    }, [o_id]);

    const saveFile = (e) => {
        if ((e.target.files).length > 0) {
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);

            var validationRes = checkImageValidation(e.target.files[0]);
            if (!validationRes.status) {
                setFile();
                setFileName('');
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: validationRes.msg,
                }));
                resetAlertData();
                return false;
            }
        }
    };

    const validation1 = useFormik({
        enableReinitialize: true,
        initialValues: formData,
        validationSchema: Yup.object({
            organizer_name: Yup.string().required('Organizer Name is required')
            .min(3, 'Organizer Name must be at least 3 characters'),
            email: Yup.string().email('Please enter a valid email!').max(255).required('Login Email is required'),
            contact_person: Yup.string().required('Contact Name is required')
            .min(3, 'Contact Name must be at least 3 characters'),
            phone_no: Yup.string().required('Contact number is required')
                .matches(/^(\+\d{1,3}[- ]?)?\d{0,10}$/, "Phone number must be in the format"),
            status: Yup.string().required('Status is required').oneOf(['Enable', 'Disable'], 'Invalid status selection'),
            account_number: Yup.string()
            .required('Account Number is required')
            .matches(/^\d+$/, 'Account number must be numeric'),
            re_account_number: Yup.string()
            .required('Account Number is required')
            .matches(/^\d+$/, 'Account number must be numeric')
            .oneOf([Yup.ref('account_number')], 'Account numbers must match'),
            ifsc_code: Yup.string()
            .required('IFSC Code is required'),
            beneficiary_name: Yup.string()
            .required('Beneficiary Name is required')
            .min(3, 'Beneficiary Name must be at least 3 characters'),
        }),
        onSubmit: async (values) => {
            try {
                let submit1 = document.getElementById('submit1');
                submit1.disabled = true;
                submit1.textContent = ('Processing...');

                const [first_name = "", ...lastNameParts] = values.organizer_name.trim().split(" ");
                const last_name = lastNameParts.join(" ");

                const formData = new FormData();
                formData.append("first_name", first_name);
                formData.append("last_name", last_name);
                formData.append("email", values.email);
                formData.append("logo", File || formData.logo); // If a new file is uploaded, send it; otherwise, send the existing logo
                formData.append("contact_person", values.contact_person);
                formData.append("phone_no", values.phone_no);
                formData.append("status", values.status);
                formData.append("account_number",values.account_number);
                formData.append("re_account_number",values.re_account_number);
                formData.append("ifsc_code",values.ifsc_code);
                formData.append("beneficiary_name",values.beneficiary_name);

                // Make the PUT request to update the organizer
                const res = await postRequestByFormData(`o-edit/${o_id}`, formData);

                if (res && res.code === 200) {
                    setFormData({
                        organizer_name: "",
                        logo: "",
                        email: "",
                        contact_person: "",
                        phone_no: "",
                        account_number: "",
                        re_account_number:"",
                        beneficiary_name: "",
                        ifsc_code: "",
                        status: "Enable",
                    });
                    navigate('/organizer-list', {
                        state: { variant: "success", message: "Organizer updated successfully!" }
                    });
                } else {
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: res.message || "Failed to update organizer.",
                    }));
                    resetAlertData();
                }

                submit1.disabled = false;
                submit1.textContent = ('Update Organizer');
            } catch (error) {
                console.error("Error: ", error);
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: "An error occurred while updating the organizer.",
                }));
                resetAlertData();
            }
        }
    });

    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w600 mb-0">Edit Organizer</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                            {AlertData.message !== "" ? (
                                <Snackbars
                                    variant={AlertData.variant}
                                    message={AlertData.message}
                                />
                            ) : (
                                ""
                            )}
                            <form>
                                <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label>Organizer Name:</label>
                                        <input
                                            type="text"
                                            className={`form-control ${validation1.touched.organizer_name && validation1.errors.organizer_name ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Organizer Name"
                                            name="organizer_name"
                                            value={validation1.values.organizer_name}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.organizer_name && validation1.touched.organizer_name && (
                                            <small className="text-danger">{validation1.errors.organizer_name}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Organizer Logo :</label>
                                        
                                        <input  
                                            type="file"
                                            className={`form-control ${validation1.touched.logo && validation1.errors.logo ? 'is-invalid' : ''}`}
                                            name="logo"
                                            onChange={saveFile}
                                        />
                                        {formData.logo && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                                            <img src={formData.logo} alt="Organizer Logo" style={{ width: '100px', height: 'auto', marginBottom: '10px' }} />
                                            <p style={{ color: 'black', margin: 0 }}>Only PNG, JPEG, JPG files allowed.</p>
                                        </div>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Contact Name :</label>
                                        <input
                                            type="text"
                                            name="contact_person"
                                            className={`form-control ${validation1.touched.contact_person && validation1.errors.contact_person ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Contact Name"
                                            value={validation1.values.contact_person || ''}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.touched.contact_person && validation1.errors.contact_person && (
                                            <small className="text-danger">{validation1.errors.contact_person}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Contact Number :</label>
                                        <input
                                            type="text"
                                            name="phone_no"
                                            className={`form-control ${validation1.touched.phone_no && validation1.errors.phone_no ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Contact Number (e.g., +91XXXXXXXXXX)"
                                            value={validation1.values.phone_no || ''}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.touched.phone_no && validation1.errors.phone_no && (
                                            <small className="text-danger">{validation1.errors.phone_no}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Email ID :</label>
                                        <input
                                            placeholder="Please Enter Email ID"
                                            name="email"
                                            type="email"
                                            className={`form-control ${validation1.touched.email && validation1.errors.email ? 'is-invalid' : ''}`}
                                            value={validation1.values.email || ''}
                                            onChange={validation1.handleChange}
                                            disabled={true}
                                        />
                                        {validation1.touched.email && validation1.errors.email && (
                                            <small className="text-danger">{validation1.errors.email}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Status :</label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            value={validation1.values.status}
                                            onChange={validation1.handleChange}
                                        >
                                            <option value="Enable">Enable</option>
                                            <option value="Disable">Disable</option>
                                        </select>
                                        {validation1.touched.status && validation1.errors.status && (
                                            <small className="text-danger">{validation1.errors.status}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Account Number:</label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            className={`form-control ${validation1.touched.account_number && validation1.errors.account_number ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Account Number"
                                            name="account_number"
                                            value={validation1.values.account_number}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.account_number && validation1.touched.account_number && (
                                            <small className="text-danger">{validation1.errors.account_number}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Re-EnterAccount Number:</label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            className={`form-control ${validation1.touched.re_account_number && validation1.errors.re_account_number ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Account Number"
                                            name="re_account_number"
                                            value={validation1.values.re_account_number}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.re_account_number && validation1.touched.re_account_number && (
                                            <small className="text-danger">{validation1.errors.re_account_number}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>IFSC Code:</label>
                                        <input
                                            type="text"
                                            className={`form-control ${validation1.touched.ifsc_code && validation1.errors.ifsc_code ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter IFSC Code"
                                            name="ifsc_code"
                                            value={validation1.values.ifsc_code}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.ifsc_code && validation1.touched.ifsc_code && (
                                            <small className="text-danger">{validation1.errors.ifsc_code}</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-3 col-md-6">
                                        <label>Beneficiary Name:</label>
                                        <input
                                            type="text"
                                            className={`form-control ${validation1.touched.beneficiary_name && validation1.errors.beneficiary_name ? 'is-invalid' : ''}`}
                                            placeholder="Please Enter Beneficiary Name"
                                            name="beneficiary_name"
                                            value={validation1.values.beneficiary_name}
                                            onChange={validation1.handleChange}
                                        />
                                        {validation1.errors.beneficiary_name && validation1.touched.beneficiary_name && (
                                            <small className="text-danger">{validation1.errors.beneficiary_name}</small>
                                        )}
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary me-2" id="submit1"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        validation1.handleSubmit();
                                        return false;
                                    }}>
                                    {'Update Organizer'}
                                </button>
                                <Link to="/organizer-list" className="btn btn-light">Cancel</Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default EditOrganizer;
